import { Box, styled } from '@mui/material';

export const MainContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  flexGrow: 1
}));
